import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class PaymentTypeDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
      valueField = 'id',
      excluded_payment_types,
      creditType
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          valueField={valueField}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='payment_type'
          type='payment_type'
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
          onPostChange={onPostChange}
          preload={preload}
          searchParams={{
            excluded_payment_types,
            credit_type: creditType,
          }}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(PaymentTypeDropdown);
